import firebase from 'firebase/compat/app';

import STORE from 'store';

const invalidateVisCache = async ({
  accountId,
  changes,
}: {
  accountId: string;
  changes: {
    dashboardGadgets?: string[];
    reportGadgets?: string[];
  };
}) => {
  await STORE.visualisations.getVisCacheVersionRef({ accountId }).set({
    changes,
    updatedOn: firebase.firestore.FieldValue.serverTimestamp(),
  });
};

export default invalidateVisCache;
